"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debtUsageControlLabel = debtUsageControlLabel;
/**
 * The accessible name of a debt-usage control (BEN-141 FP-098), ONE copy for both
 * clients (rule 17: added in web's FP-098 PR, reviewed by mobile).
 *
 * Mobile's walk (PLN-F66/F68, 2026-10-05): web's FA §3 named every debt-usage select
 * "How you use this account", identically, and web's §8 Edit modal and mobile's FA
 * sheet named theirs nothing that said which account. A screen reader heard "I carry
 * a balance" with no account. The name carries the account's name and last four,
 * with the last four said as "ending in", not bullets, which a screen reader reads
 * out as "bullet".
 */
function debtUsageControlLabel(account, lastFour) {
    const ending = lastFour ? ` ending in ${lastFour}` : "";
    return `How you use ${account}${ending}`;
}
//# sourceMappingURL=debtUsageLabel.js.map